import { createQueryKeys } from "@lukemorales/query-key-factory";
import { skipToken } from "@tanstack/react-query";

import type { Subscription } from "@/shared/domains";
import { getSubscriptionProductWithAvailableHigherPrices } from "./api";

export const subscriptionsQueries = createQueryKeys("subscriptions", {
  detail: (subscriptionId?: Subscription["id"]) => ({
    queryKey: [subscriptionId],
    contextQueries: {
      product: {
        queryKey: null,
        contextQueries: {
          withAvailableHigherPrices: {
            queryKey: null,
            queryFn: subscriptionId
              ? () =>
                  getSubscriptionProductWithAvailableHigherPrices(
                    subscriptionId,
                  )
              : (skipToken as never),
          },
        },
      },
    },
  }),
});
